import React from "react";
import { FileQuestion } from "lucide-react";
import AssetDownloadButton from "./AssetDownloadButton";

interface UnsupportedAssetViewProps {
  /** The asset's file extension (e.g. `csv`), used in the message. */
  extension: string;
  /** Triggers a browser download of the asset. */
  onDownload: () => Promise<void>;
}

/**
 * Rendered for additional assets the WebApp can't preview inline (anything not
 * in the renderable allow-list, e.g. `.csv`, `.json`, images). Shows a short
 * "preview not supported" message and a Download button.
 */
const UnsupportedAssetView: React.FC<UnsupportedAssetViewProps> = ({
  extension,
  onDownload,
}) => {
  const extLabel = extension ? `.${extension}` : "this";

  return (
    <div className="h-full overflow-y-auto bg-background">
      <div className="flex items-center justify-center py-12">
        <div className="flex flex-col items-center gap-4 text-center">
          <FileQuestion className="h-10 w-10 text-muted-foreground" />
          <p className="text-sm text-muted-foreground">
            Preview is not supported for {extLabel} files.
          </p>
          <AssetDownloadButton onDownload={onDownload} />
        </div>
      </div>
    </div>
  );
};

export default UnsupportedAssetView;
